export interface ICategoriaEmpresa {
  id?: number;
  nombre?: string | null;
  oculto?: boolean | null;
}

export class CategoriaEmpresa implements ICategoriaEmpresa {
  constructor(public id?: number, public nombre?: string | null, public oculto?: boolean | null) {
    this.oculto = this.oculto = false;
  }
}
